import { at_offside_map, extra_jsy_ops, op_template_str } from './jsy_operators.jsy'
import { checkOptionalComma } from './optional_comma.jsy'

const rx_leading_space = /^[ \t]+/ ;

const root_head = Object.freeze @: __proto__: null

export const transpile_visitor = @{}
  __proto__: null

  *ast_iter(jsy_ast) ::
    this.start()

    let ln, fin
    for ln of jsy_ast ::
      fin = this.ast_line(ln)
      yield `${fin?.join('') ?? fin ?? ''}\n`

    fin = this.finish()
    yield `${fin?.join('') ?? fin ?? ''}\n`


  ast_line(ln) ::
    if ln.is_blank ::
      return this.blank_line(ln)

    this.start_line(ln)
    this.v$offside_indent(ln.indent)

    let prev = ln.indent
    for let part of ln.content ::
      let fn_visit = `v$${part.type}`
      if undefined === this[fn_visit] ::
        throw new Error @ `JSY transpile function "${fn_visit}" not found`

      this[fn_visit]( part, ln, prev )
      prev = part

    return this.finish_line(ln)

  start() ::
    this.lineno = 0
    this.head = root_head

  finish() ::
    if root_head !== this.head ::
      throw new Error @ 'Excess stack at finish'

  blank_line(ln) ::
    this.lineno ++

  start_line(ln) ::
    this.lineno ++
    this.cur_ln = ln
    let line_src = this._cur = []
    line_src.finish_ops = []

  finish_line(ln) ::
    let line_src = this._cur
    for let fn of line_src.finish_ops || [] ::
      line_src = fn(line_src, ln)

    let comma_body = this.head.comma_body
    if undefined !== comma_body ::
      comma_body.push @ '\n'

    return line_src

  emit_raw(src) ::
    if src :: this._cur.push @ src

  emit(src, loc_start) ::
    if loc_start && this.addSourceMapping ::
      const column = this._cur.join('').length
      this.addSourceMapping @:
        generated: @{} line: this.lineno, column
        original: @{} line: loc_start.line, column: loc_start.column

    const comma_body = this.head.comma_body
    if undefined !== comma_body ::
      comma_body.push @ src

    this._cur.push @ src

  emit_indent(indent) ::
    const cur = this._cur
    if 0 !== cur.length ::
      throw new Error @ `Indent must be first element of cur list`

    const comma_body = this.head.comma_body
    if undefined === comma_body ::
      cur.push @ indent
      return

    comma_body.splice @ 0, comma_body.length,
      comma_body.join('').trimLeft()

    if comma_body.len_inner != this.cur_ln.len_indent ::
      cur.push @ indent
      return

    cur.push @ indent || ' '

    let finish_commas = (cur) => ::
      const pre = comma_body[0]
      if ! pre :: return cur

      const post = comma_body.slice(1).join('')
      const opt_comma = this.checkOptionalComma @ comma_body.op, pre, post
      if opt_comma ::
        if cur[0].length > 1 ::
          cur[0] = cur[0].replace(/\s\s$/, ', ')
        else cur[0] = ','
        comma_body.shift()
      return cur

    cur.finish_ops.push @ finish_commas

  _checkOptionalComma: checkOptionalComma
  checkOptionalComma

  stack_push(op, p) ::
    if op.foldTop && this.head.isFoldable ::
      this.stack_pop()

    if null === op.post ::
      if op.pre :: this.emit @ op.pre
      return

    const {len_indent, loc} = p
    const head = @{} __proto__: this.head
      op, len_indent, loc
      isFoldable: op.isFoldable
      nestBreak: op.nestBreak

    if ',' == op.implicitSep ::
      const comma_body = head.comma_body = []
      comma_body.op = op
      comma_body.len_inner = this.cur_ln.len_inner
    else head.comma_body = undefined

    if op.in_nested_block ::
      head.in_nested_block = true
      head.nested_block_indent = len_indent

    head.tail = [this.head].concat(head.tail || [])

    let src_pre = head.op.pre
    if src_pre :: this.emit @ src_pre

    this.head = head

  stack_pop(c) ::
    let head = this.head
    let next = head.tail[0]
    this.head = next

    if next.comma_body ::
      let substitute = head.op.substitute ?? @ // explicit substution
        ',' == head.op.implicitSep ? 'expr' // is a comma-based expression
        : /[\)\]]\s*$/.test(head.op.post) ? 'expr' // ends as call or index expr
        : null

      if null != substitute ::
        // internal op was an expression; simplify for comma_body
        next.comma_body.push(` ${substitute} `)

    let src_post = head.op.post
    if src_post ::
      this.emit @ c ? ' '+src_post : src_post

  v$jsy_unknown(p) ::
    throw p.loc.start.syntaxError @
      `JSY unknown operator "${p.op}"`

  v$jsy_kw(p) ::
    const kw_op = p.explicit
      ? extra_jsy_ops.kw_explicit
      : extra_jsy_ops.kw_normal

    this.stack_push @ kw_op.kwExpandOp(p), p

  v$jsy_op(p) ::
    this._jsy_op @ at_offside_map[p.op], p

  v$jsy_op_args(p) ::
    this._jsy_op @ at_offside_map[p.op], p

  _jsy_op(jsy_op, p) ::
    if ! jsy_op ::
      throw new Error @ `JSY op handler not found for "${p.op}"`

    if jsy_op.warn :: jsy_op.warn(p)

    if jsy_op.opResolve ::
      jsy_op = validate_jsy_op_item @ jsy_op.opResolve(p)
      if jsy_op.warn :: jsy_op.warn(p)

    this._jsy_op_exec(jsy_op, p)

  _jsy_op_exec(jsy_op, p) ::
    if jsy_op.is_kw_close ::
      this._dedent_nested_block(p)

    this.stack_push @ jsy_op, p


  _dedent_nested_block(p) ::
    if ! this.head.in_nested_block :: return

    if null != p ::
      p.len_indent = this.head.nested_block_indent

    let c = 0, done=false
    while this.head && this.head.in_nested_block && ! done ::
      done = this.head.op.in_nested_block
      this.stack_pop @ c++

  _dedent_multi_ops() ::
    if ! this.head.loc :: return

    const line = this.cur_ln.loc.start.line
    const t = this.head.tail
      .filter @ t => t.loc && line === t.loc.start.line
      .pop()

    if undefined === t :: return

    let c = 0
    while t !== this.head && !this.head.nestBreak ::
      this.stack_pop @ c++

  v$offside_dedent(p) ::
    if ! p.ends_with_jsy_op ::
      this._dedent_multi_ops()

    let c = 0
    while this.head.len_indent >= p.len_dedent ::
      this.stack_pop @ c++


  v$offside_indent(p) ::
    this.emit_indent @ p.indent


  v$template_param(p) :: this._param @ extra_jsy_ops.tmpl_param, p
  v$template_param_end(p) :: this._param_end @ p

  v$jsx_param(p) :: this._param @ extra_jsy_ops.jsx_param, p
  v$jsx_param_end(p) :: this._param_end @ p

  _param(op, p) ::
    this.stack_push @ op, p
    this.emit_raw @ p.content

  _param_end(p) ::
    this._dedent_nested_block(p)
    this.emit_raw @ p.content

    let comma_body = this.head.comma_body
    if undefined !== comma_body ::
      // fixup comma_body with simplified template param
      comma_body.push @ 'null }'


  v$str_template(p, ln, p0) ::
    if p.tmpl_opened ::
      this.stack_push @ op_template_str, p

    if p0 === ln.indent && p.mlctx ::
      let indent = this._cur.pop()
      this._cur.push @ indent.slice(p.mlctx.col)

    this.emit @ p.content, p.loc.start

    if p.tmpl_closed ::
      this.stack_pop()
      let comma_body = this.head.comma_body
      if undefined !== comma_body ::
        // fixup comma_body with simplified template param
        comma_body.push @ '`tmpl_expr`'

  v$src(p, ln, p0) ::
    let content = p.content
    if {jsy_op:1, jsy_kw:1}[p0.type] && rx_leading_space.test(content) ::
      content = content.replace(rx_leading_space, '')

    this.emit @ content, p.loc.start


  v$preprocessor(p, ln) :: this.emit(p.content)
  v$preprocessor_sz(p, ln) :: this.emit(p.ans)
  v$preprocessor_inc(p, ln) ::
    if this.inc_preprocessor ::
      this.emit @ `//+~${p.content}`
  v$preprocessor_exc(p, ln) ::
    if this.inc_preprocessor ::
      this.emit @ `//-~${p.content}`
  v$exclude_line(p, ln) ::
    if this.inc_preprocessor ::
      this.emit(p.content)
  v$exclude_part(p, ln) ::
    if this.inc_preprocessor ::
      this.emit(p.content)

  v$str: direct_src
  v$str1: direct_src
  v$str2: direct_src

  v$regexp: direct_src

  v$jsx_frag: direct_src
  v$jsx_frag_close: direct_src
  v$jsx_tag: direct_src
  v$jsx_tag_part: direct_src
  v$jsx_tag_close: direct_src
  v$jsx_attr_name: direct_src
  v$jsx_attr_name_only: direct_src
  v$jsx_attr_str1: direct_src
  v$jsx_attr_str2: direct_src
  v$jsx_content: direct_src
  v$jsx_content_expr: direct_src

  v$hashbang: raw_src
  v$comment_eol: raw_src
  v$comment_multi: raw_src


function raw_src(p) :: this.emit_raw @ p.content
function direct_src(p) :: this.emit @ p.content, p.loc.start

function validate_jsy_op_item(jsy_op_item) ::
  let {pre, post} = jsy_op_item

  if null !== pre && 'string' !== typeof pre ::
    throw new Error @ 'Invalid resolved jsy_op_item.pre result'
  if null !== post && 'string' !== typeof post ::
    throw new Error @ 'Invalid resolved jsy_op_item.post result'

  return jsy_op_item

